module.exports = __webpack_public_path__ + "img/PL08279.3e649493.png";